
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import SummaryHomeworkCard from './card/SummaryHomeworkCard.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    NewSwiper,
    SummaryHomeworkCard
  }
})
export default class SummaryHomework extends Vue {
  animationClass: string = ''

  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
    onEndLoadMore: (hasMore: boolean) => void
  }

  @Emit('open-content')
  handleOpenContent(id: number) {
    return {
      homeworkId: id,
      type: 'homework'
    }
  }

  // 触发lazy加载视区展示
  onSwiperChange() {
    if (!this.animationClass) {
      this.animationClass = 'lazy-trigger'
    }
  }
  onContentMousedown() {
    if (this.animationClass) {
      this.animationClass = ''
    }
  }

  prev() {
    if (!this.swiper) return

    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return

    this.swiper.handleNext()
  }

  async handleLoadMore() {
    console.log('handleLoadMore')

    if (!this.swiper) return

    await this.PageStore.loadMoreHomeworks()

    this.swiper.onEndLoadMore(this.PageStore.homeWorkStatus.hasMore)
  }

  get PageStore() {
    return this.$store.$courseV2.Summary
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {
    this.PageStore.resetHomeWorkStatus()
  }
}
